import React from 'react';
import { Routes, Route } from 'react-router-dom';
import logo from './logo.svg';
import './App.css';
import Login from './components/login/Login';
import PublicRoute from './router/PublicRoute';
import PrivateRoute from './router/PrivateRoute';
import Layout from './components/login/Layout';
import Profile from './components/profile/Profile';
import { Toaster } from 'react-hot-toast';
import Inventory from './components/inventory/Inventory';

function App() {
  return (
    <div>
      <Routes>
        <Route path="/login" element={<PublicRoute Component={Login} />} />
        <Route path="/inventory" element={<Layout />}>
          <Route index element={<PrivateRoute Component={Inventory} />} />

          <Route
            path="inventory"
            element={<PrivateRoute Component={Inventory} />}
          />
        </Route>
        <Route path="*" element={<PublicRoute Component={Login} />} />
      </Routes>
      <Toaster
        position="top-right"
        reverseOrder={false}
        containerStyle={{
          top: 80,
        }}
      />
    </div>
  );
}

export default App;
